import { Box, Button, TextField, Typography } from "@material-ui/core";
import * as firebase from "firebase/app";
import "firebase/analytics";
import "firebase/firestore";
import * as React from "react";
import { SAMPLE_LINK, guessBuyLink } from "../Top/Top";
import emailjs from "@emailjs/browser";
import { logEvent } from "../../utils/Analytics";

type Status = "waiting" | "invalid" | "sending" | "success" | "error";
const expression: RegExp = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const FreeChapter = () => {
  const [email, setEmail] = React.useState<string>("");
  const [status, setStatus] = React.useState<Status>("waiting");

  const changeEmail = (e: string) => {
    const valid = expression.test(e);
    setEmail(e);
    if (valid) {
      setStatus("waiting");
    } else {
      setStatus("invalid");
    }
  };

  const addEmail = async () => {
    setStatus("sending");
    try {
      // Add to database
      const db = firebase.firestore();
      await db.collection("contacts").add({
        email,
        time: firebase.firestore.FieldValue.serverTimestamp(),
      });

      const buyLink = guessBuyLink();

      // send email
      await emailjs.send(
        "service_f32hdvf",
        "template_tzkb5is",
        { sample_url: SAMPLE_LINK, buy_url: buyLink.paper, to_email: email },
        "amWHqFcMImjHFzpHe"
      );

      // await db.collection("emails").add({
      //  to: email,
      //  message: {
      //    subject: "The Scaevola Conspiracy - Your Free Chapter",
      //    html: `Hi there, <br/><br/>thanks for your interest in <b>The Scaevola Conspiracy</b>! <br/><br/>Click here to download your free sample: <a href="${SAMPLE_LINK}">Free Sample</a>. `,
      //  },
      // });
      setStatus("success");
      logEvent("sample-email-sent", { email });
    } catch (e) {
      console.error(e);
      setStatus("error");
      logEvent("sample-email-error", { email, error: e });
    }
  };

  return (
    <Box mt={8} mx={4}>
      <Box mb={4} mt={2} textAlign="center">
        <Typography variant="h2">Your Free Chapter</Typography>
      </Box>
      <Box
        maxWidth={1140}
        marginLeft="auto"
        marginRight="auto"
        textAlign="center"
      >
        <Typography variant="body1" color="textSecondary">
          Enter your email address to receive a free chapter of the book!
        </Typography>
        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
          <Box mr={1}>
            <TextField
              type="email"
              value={email}
              placeholder="Your email"
              variant="outlined"
              margin="dense"
              disabled={!(status === "waiting" || status === "invalid")}
              onChange={(e) => changeEmail(e.target.value)}
            />
          </Box>
          <Box ml={1}>
            <Button
              variant="contained"
              color="primary"
              disabled={status !== "waiting" || !email}
              onClick={() => addEmail()}
            >
              {status === "error"
                ? "An Error Occurred"
                : status === "invalid"
                ? "Invalid Email"
                : status === "sending"
                ? "Sending..."
                : status === "success"
                ? "Success"
                : "Send Chapter"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/FreeChapter/FreeChapter.tsx